const weatherIcons = {
    0: "wi wi-tornado", // tornado
    1: "wi wi-hurricane", // tropical storm
    2: "wi wi-hurricane", // hurricane
    3: "wi wi-thunderstorm", // severe thunderstorm
    4: "wi wi-thunderstorm", // thunderstorm
    5: "wi wi-rain-mix", // mixed rain and snow
    6: "wi wi-rain-mix", // mixed rain and sleet
    7: "wi wi-sleet", // mixed snow and sleet
    8: "wi wi-rain-wind", // freezing drizzle
    9: "wi wi-sprinkle", // drizzle
    10: "wi wi-rain-wind", // freezing rain
    11: "wi wi-showers", // showers
    12: "wi wi-rain", // rain
    13: "wi wi-snow", // snow flurries
    14: "wi wi-snow", // light snow showers
    15: "wi wi-snow-wind", // blowing snow
    16: "wi wi-snow", // snow
    17: "wi wi-hail", // hail
    18: "wi wi-sleet", // sleet
    19: "wi wi-dust", // dust
    20: "wi wi-fog", // foggy
    21: "wi wi-day-haze", // haze
    22: "wi wi-smoke", // smokey
    23: "wi wi-strong-wind", // blustery
    24: "wi wi-windy", // windy
    25: "wi wi-snowflake-cold", // cold
    26: "wi wi-cloudy", // cloudy
    27: "wi wi-night-alt-cloudy", // mostly cloudy (night)
    28: "wi wi-night-alt-cloudy", // mostly cloudy (day)
    29: "wi wi-night-alt-partly-cloudy", // partly cloudy (night)
    30: "wi wi-day-sunny-overcast", // partly cloudy (day)
    31: "wi wi-night-clear", // clear (night)
    32: "wi wi-day-sunny", // sunny
    33: "wi wi-night-partly-cloudy", // fair (night)
    34: "wi wi-day-sunny-overcast", // fair (day)
    35: "wi wi-rain-mix", // mixed rain and hail
    36: "wi wi-hot", // hot
    37: "wi wi-thunderstorm", // isolated thunderstorms
    38: "wi wi-thunderstorm", // scattered thunderstorms
    39: "wi wi-day-showers", // scattered showers (day)
    40: "wi wi-rain-wind", // heavy rain
    41: "wi wi-day-snow", // scattered snow showers (day)
    42: "wi wi-snow", // heavy snow
    43: "wi wi-snow-wind", // blizzard
    44: "wi wi-na", // not available
    45: "wi wi-night-alt-showers", // scattered showers (night)
    46: "wi wi-night-alt-snow", // scattered snow showeres (night)
    47: "wi wi-storm-showers", // scattered thundershowers
};

export { weatherIcons };
